import { render, staticRenderFns } from "./AdminPrograms.vue?vue&type=template&id=553d7a04"
import script from "./AdminPrograms.vue?vue&type=script&lang=js"
export * from "./AdminPrograms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('553d7a04')) {
      api.createRecord('553d7a04', component.options)
    } else {
      api.reload('553d7a04', component.options)
    }
    module.hot.accept("./AdminPrograms.vue?vue&type=template&id=553d7a04", function () {
      api.rerender('553d7a04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/AdminPrograms.vue"
export default component.exports